import {
  Button,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
  Input,
  Label,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Textarea,
} from "@egaranti/components";

import { useState } from "react";
import { useTranslation } from "react-i18next";

const SerialNumberInput = ({ form }) => {
  const { t } = useTranslation();
  const [startRange, setStartRange] = useState("");
  const [endRange, setEndRange] = useState("");
  const [prefix, setPrefix] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);

  const generateRange = () => {
    const start = parseInt(startRange);

    const numbers = Array.from(
      { length: parseInt(endRange) - start + 1 },
      (_, i) => {
        const serialNumber = (start + i).toString();
        return prefix + serialNumber.padStart(startRange.length, "0");
      },
    );

    const currentSerialNumbers = form.getValues("serialNumber") || [];
    const allSerialNumbers = [
      ...new Set([...currentSerialNumbers, ...numbers]),
    ];

    if (allSerialNumbers[0] === "") {
      allSerialNumbers.shift();
    }

    form.setValue("serialNumber", allSerialNumbers, { shouldDirty: true });
    setPopoverOpen(false);
  };

  return (
    <div className="formBox mt-4 flex flex-col gap-4">
      <h2 className="text-lg font-medium">
        {t("productsPage.serialNumberSettings", "Seri Numara Ayarları")}
      </h2>
      <div className="flex items-end gap-4">
        <FormField
          control={form.control}
          name="serialNumber"
          render={({ field: { onChange, value = [], ...field } }) => {
            return (
              <FormItem className="flex-1">
                <Label>
                  {t("productsPage.serialNumbers", "Seri Numaraları")}
                </Label>
                <FormControl>
                  <Textarea
                    {...field}
                    value={Array.isArray(value) ? value.join("\n") : ""}
                    onChange={(e) => {
                      const lines = e.target.value.split("\n");
                      onChange(lines);
                    }}
                    placeholder={t(
                      "productsPage.serialNumbersPlaceholder",
                      "Her satıra bir seri numarası giriniz excel'den sütünu kopyala yapıştır yapabilirsiniz.",
                    )}
                    className="min-h-[100px]"
                  />
                </FormControl>
                <FormDescription>
                  {t(
                    "productsPage.serialNumbersPlaceholder",
                    "Her satıra bir seri numarası giriniz excel'den sütünu kopyala yapıştır yapabilirsiniz.",
                  )}
                </FormDescription>
                <FormMessage />
              </FormItem>
            );
          }}
        />
        <div className="flex gap-2">
          <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
            <PopoverTrigger asChild>
              <Button type="button" variant="secondaryGray">
                {t("productsPage.addSerialNumberRange", "Aralık Gir")}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 bg-white">
              <div className="grid gap-4">
                <div className="space-y-2">
                  <h4 className="font-medium leading-none">
                    {t(
                      "productsPage.serialNumberRange",
                      "Seri Numarası Aralığı",
                    )}
                  </h4>
                  <p className="text-muted-foreground text-sm">
                    {t(
                      "productsPage.serialNumberRangeDesc",
                      "Başlangıç ve bitiş değerlerini girerek aralık oluşturun",
                    )}
                  </p>
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="prefix">
                    {t("productsPage.prefix", "Ön ek")}
                  </Label>
                  <Input
                    id="prefix"
                    type="text"
                    value={prefix}
                    onChange={(e) => setPrefix(e.target.value)}
                    placeholder={t("productsPage.prefixPlaceholder", "ABC-")}
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="grid gap-2">
                    <Label htmlFor="startRange">
                      {t("productsPage.startRange", "Başlangıç")}
                    </Label>
                    <Input
                      id="startRange"
                      type="number"
                      min="0"
                      value={startRange}
                      onChange={(e) => setStartRange(e.target.value)}
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="endRange">
                      {t("productsPage.endRange", "Bitiş")}
                    </Label>
                    <Input
                      id="endRange"
                      type="number"
                      min="0"
                      value={endRange}
                      onChange={(e) => setEndRange(e.target.value)}
                    />
                  </div>
                </div>
                <Button type="button" onClick={generateRange}>
                  {t("common.add", "Ekle")}
                </Button>
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default SerialNumberInput;
